const SCROLL_AMOUNT = 280;

// ── Lightbox ──
let lb, lbContent, lbImg, lbThumbs, lbCounter, lbPrev, lbNext, lbCloseBtn;
let gallery = [], curIdx = 0;

const lbUpdateCounter = () => {
  const n = gallery.length;
  lbCounter.textContent = n > 1 ? `${curIdx + 1} / ${n}` : '';
};

const lbUpdateNav = () => {
  const show = gallery.length > 1 ? 'flex' : 'none';
  lbPrev.style.display = show;
  lbNext.style.display = show;
};

const lbUpdateThumbs = () => {
  Array.from(lbThumbs.children).forEach((t, i) => {
    const active = i === curIdx;
    t.style.opacity = active ? '1' : '0.4';
    t.style.outlineColor = active ? 'rgba(255,255,255,0.85)' : 'transparent';
  });
  const active = lbThumbs.children[curIdx];
  if (active) active.scrollIntoView({ inline: 'nearest', block: 'nearest' });
};

const lbBuildThumbs = () => {
  lbThumbs.innerHTML = '';
  if (gallery.length <= 1) return;
  gallery.forEach((src, i) => {
    const img = document.createElement('img');
    img.src = src; img.draggable = false;
    img.style.height = '44px'; img.style.width = '66px';
    img.style.objectFit = 'cover'; img.style.borderRadius = '4px';
    img.style.cursor = 'pointer'; img.style.flexShrink = '0';
    img.style.outline = '2px solid transparent'; img.style.outlineOffset = '2px';
    img.addEventListener('click', (e) => { e.stopPropagation(); lbNavigate(i); });
    lbThumbs.appendChild(img);
  });
  lbUpdateThumbs();
};

const lbNavigate = (newIdx) => {
  if (newIdx === curIdx) return;
  lbImg.style.opacity = '0';
  setTimeout(() => {
    curIdx = newIdx; lbImg.src = gallery[curIdx]; lbImg.style.opacity = '1';
    lbUpdateCounter(); lbUpdateThumbs();
  }, 150);
};

export const lbOpen = (images, idx) => {
  gallery = images; curIdx = idx;
  lbImg.style.opacity = '1'; lbImg.src = gallery[curIdx];
  lbBuildThumbs(); lbUpdateNav(); lbUpdateCounter();
  lb.style.opacity = '0'; lb.style.display = 'flex';
  requestAnimationFrame(() => { lb.style.opacity = '1'; });
  document.body.style.overflow = 'hidden';
};

const lbClose = () => {
  lb.style.opacity = '0';
  setTimeout(() => { lb.style.display = 'none'; lbImg.src = ''; lbThumbs.innerHTML = ''; }, 150);
  document.body.style.overflow = '';
};

export const initLightbox = () => {
  lb = document.getElementById('lightbox');
  if (!lb) return;
  lbContent = document.getElementById('lb-content');
  lbImg = document.getElementById('lb-img');
  lbThumbs = document.getElementById('lb-thumbs');
  lbCounter = document.getElementById('lb-counter');
  lbPrev = document.getElementById('lb-prev');
  lbNext = document.getElementById('lb-next');
  lbCloseBtn = document.getElementById('lb-close');

  lb.addEventListener('click', (e) => { if (e.target === lb) lbClose(); });
  lbContent.addEventListener('click', (e) => { e.stopPropagation(); });
  lbCloseBtn.addEventListener('click', (e) => { e.stopPropagation(); lbClose(); });
  lbPrev.addEventListener('click', (e) => { e.stopPropagation(); lbNavigate((curIdx - 1 + gallery.length) % gallery.length); });
  lbNext.addEventListener('click', (e) => { e.stopPropagation(); lbNavigate((curIdx + 1) % gallery.length); });
  document.addEventListener('keydown', (e) => {
    if (lb.style.display !== 'flex') return;
    if (e.key === 'Escape') lbClose();
    if (e.key === 'ArrowLeft') lbNavigate((curIdx - 1 + gallery.length) % gallery.length);
    if (e.key === 'ArrowRight') lbNavigate((curIdx + 1) % gallery.length);
  });

  // Expose globally for inline onclick handlers in review images
  window.lbOpen = lbOpen;
};

export const initPhotoStrips = () => {
  document.querySelectorAll('.photo-strip').forEach((strip) => {
    const wrap = strip.parentElement;
    const prev = wrap.querySelector('.strip-prev');
    const next = wrap.querySelector('.strip-next');

    const updateArrows = () => {
      const atStart = strip.scrollLeft < 2;
      const atEnd = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 2;
      prev.style.display = atStart ? 'none' : 'flex';
      next.style.display = atEnd ? 'none' : 'flex';
    };
    updateArrows();
    strip.addEventListener('scroll', updateArrows);
    strip.querySelectorAll('img').forEach((img) => { img.addEventListener('load', updateArrows); });
    prev.addEventListener('click', () => { strip.scrollBy({ left: -SCROLL_AMOUNT, behavior: 'smooth' }); });
    next.addEventListener('click', () => { strip.scrollBy({ left: SCROLL_AMOUNT, behavior: 'smooth' }); });

    let startX, startScroll, dragging = false, hasDragged = false;
    strip.addEventListener('mousedown', (e) => {
      e.preventDefault(); dragging = true; hasDragged = false;
      startX = e.pageX - strip.offsetLeft; startScroll = strip.scrollLeft;
      strip.classList.add('dragging');
    });
    document.addEventListener('mousemove', (e) => {
      if (!dragging) return;
      const dx = (e.pageX - strip.offsetLeft) - startX;
      if (Math.abs(dx) > 4) hasDragged = true;
      strip.scrollLeft = startScroll - dx;
    });
    document.addEventListener('mouseup', () => { dragging = false; strip.classList.remove('dragging'); });

    strip.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        if (hasDragged) return;
        const liveLinks = Array.from(strip.querySelectorAll('a'));
        const idx = liveLinks.indexOf(link);
        if (idx === -1) return;
        lbOpen(liveLinks.map((a) => a.href), idx);
      });
    });
  });
};
